import { useEffect } from "react";
import FilterValueProps from "types/FilterValueProps";

interface useSelectedOptionsProps{
  parentFilterId?: number
  allOptions: Array<FilterValueProps>
  options: Array<FilterValueProps>
  setDefaultOption: Function
  setFilterParam: Function
  isMulti: boolean
  selectAllIsDefault: boolean
  param: string
  selectAll: Function
  onSelectOption: Function
}

const useSetDefaultOption = (props: useSelectedOptionsProps) => {
  useEffect(() => {
    if(props.options?.length > 0){
      props.setDefaultOption({
        parentFilterId: props.parentFilterId,
        allOptions: props.allOptions,
        options: props.options,
        setFilterParam: props.setFilterParam,
        isMulti: props.isMulti,
        selectAllIsDefault: props.selectAllIsDefault,
        param: props.param,
        selectAll: props.selectAll,
        onSelectOption: props.onSelectOption
      })
    }
  }, [props.options])
}


export default useSetDefaultOption 